import { render, staticRenderFns } from "./Escolaridade.vue?vue&type=template&id=7ac4a5f2"
import script from "./Escolaridade.vue?vue&type=script&lang=js"
export * from "./Escolaridade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports